import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";

export const lenisRef = { current: null };

export function useLenis() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    // Auf Touch-/Mobilgeräten KEIN Lenis: natives Touch-Scrollen ist zuverlässiger
    const isTouch =
      window.matchMedia("(hover: none) and (pointer: coarse)").matches ||
      window.innerWidth < 1024;
    if (isTouch) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, wheelMultiplier: 0.95 });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);
}

export function scrollTo(target, opts = {}) {
  if (lenisRef.current) return lenisRef.current.scrollTo(target, opts);
  if (typeof target === "number") return window.scrollTo({ top: target, behavior: opts.immediate ? "auto" : "smooth" });
  const el = typeof target === "string" ? document.querySelector(target) : target;
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY + (opts.offset || 0);
    window.scrollTo({ top, behavior: "smooth" });
  }
  return undefined;
}
